import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { AddressComponent } from "./components/address/address.component";
import { CheckboxComponent } from "./components/checkbox/checkbox.component";
import { DropdownComponent } from "./components/dropdown/dropdown.component";
import { EmptyComponent } from "./components/empty/empty.component";
import { LabelComponent } from "./components/label/label.component";
import { ListComponent } from "./components/list/list.component";
import { TextAreaComponent } from "./components/textarea/textarea.component";
import { TextboxComponent } from "./components/textbox/textbox.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LunaCommonModule } from "../common/common.module";
import { SummaryComponent } from "./components/summary/summary.component";
import { ReviewCommentsComponent } from "./components/review-comments/review-comments.component";
import { ReportHeaderImageComponent } from "./components/report-header-image/report-header-image.component";
import { ReportHeaderDefaultComponent } from "./components/report-header-default/report-header-default.component";
import { ReportFooterDefaultComponent } from "./components/report-footer-default/report-footer-default.component";
import { RadioComponent } from "./components/radio/radio.component";
import { ButtonLinkComponent } from "./components/button-link/button-link.component";
import { YesNoToggleComponent } from "./components/yesnotoggle/yesnotoggle.component";
import { MultiselectCheckboxComponent } from "./components/multiselect-checkbox/multiselect-checkbox.component";
import { PdfGeneratorComponent } from "./components/pdf-generator/pdf-generator.component";

import { ESignatureComponent } from "./components/e-signature/e-signature.component";
import { ChiefsSignatureComponent } from "./components/chiefs-signature/chiefs-signature.component";

import { GisModule } from "../gis/gis.module";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { ReportPdfViewComponent } from './components/report-selector/report-pdf-view/report-pdf-view.component';
import { ReportTemplateSelectorComponent } from './components/report-selector/report-template-selector/report-template-selector.component';
import { ReportTemplateEditorComponent } from './components/report-selector/report-template-editor/report-template-editor.component';
import { ReportSelectorService } from './services/report-selector.service';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { MapControlComponent } from './components/map/map-control.component';
import { RouteControlComponent } from "./components/route/route-control.component";
import { ContextInteractionService } from "./services/context-interaction.service";

import { OwlDateTimeModule, OwlNativeDateTimeModule } from "@danielmoncada/angular-datetime-picker";

//import "froala-editor/js/froala_editor.pkgd.min.js";
import { FormControlBaseModule } from "./component-base/form-control-base.module";
import { PipesModule } from "../common/pipes/pipes.module";
import { FileUploadModule } from "./components/file-upload/file-upload.module";
import { DataQueryButtonComponent } from './components/data-query-button/data-query-button.component';
import { FileUploadDisplayComponent } from './components/summary/component-displays/file-upload-display/file-upload-display.component';
import { PhoneInputComponent } from './components/phone-input/phone-input.component';
import { FlowDataTableComponent } from "./components/data-table/flow-data-table.component";
import { DataTableModule } from "../common/components/data-table/data-table.module";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgxMaskModule, NgxMaskPipe } from "ngx-mask";
import { TextboxDisplayComponent } from './components/summary/component-displays/textbox-display/textbox-display.component';
import { WellsModule } from "../wells/wells.module";
import { AreaOfReviewMapComponent } from "./components/area-of-review-map/area-of-review-map.component";

import { FlowPdfViewerComponent } from './components/flow-pdf-viewer/flow-pdf-viewer.component';
import { SummaryItemComponent } from './components/summary/summary-item/summary-item.component';
import { NewCasingPlanComponent } from './components/new-casing-plan/new-casing-plan.component';
import { NewCasingPlanBackgroundInfoComponent } from './components/new-casing-plan/new-casing-plan-background-info/new-casing-plan-background-info.component';
import { WellSegmentWizardComponent } from './components/new-casing-plan/well-segment-wizard/well-segment-wizard.component';
import { WellSegmentPrecisComponent } from './components/new-casing-plan/well-segment-precis/well-segment-precis.component';
import { CasingDataPagesComponent } from './components/new-casing-plan/casing-data-pages/casing-data-pages.component';
import { CasingPlan2dDetailVerticalComponent } from "./components/casing-plan-schematic/casing-plan-2d/detail/casing-plan-2d-detail-vertical.component";
import { CasingPlan2dDetailHorizontalComponent } from "./components/casing-plan-schematic/casing-plan-2d/detail/casing-plan-2d-detail-horizontal.component";
import { CasingPlan2dDetailBaseComponent } from './components/casing-plan-schematic/casing-plan-2d/detail/casing-plan-2d-detail-base.component';
import { CasingPlan2dDetailDirectionalComponent } from "./components/casing-plan-schematic/casing-plan-2d/detail/casing-plan-2d-detail-directional.component";
import { CasingPlanAlertComponent } from './components/new-casing-plan/casing-plan-alert/casing-plan-alert.component';
import { CasingPlanAlertService } from "./components/new-casing-plan/services/casing-plan-alert.service";
import { CasingSizeAndDepthComponent } from './components/new-casing-plan/casing-size-and-depth/casing-size-and-depth.component';
import { GoToPageDisplayComponent } from './components/summary/component-displays/go-to-page-display/go-to-page-display.component';
import { AccordionModule } from "../common/components/accordion/accordion.module";
import { SummaryConfigItemComponent } from './components/summary/summary-config-item/summary-config-item.component';
import { DatePickerComponent } from './components/datepicker/datepicker.component';
import { DefaultDisplayComponent } from './components/summary/component-displays/default-display/default-display.component';
import { CheckboxDisplayComponent } from './components/summary/component-displays/checkbox-display/checkbox-display.component';
import { FlowButtonOverrideService } from "../flow/services/flow-button-override.service";
import { CasingPlanGridComponent } from "./components/casing-plan-grid/casing-plan-grid.component";
import { SummaryFlowViewComponent } from './components/summary/summary-flow-view/summary-flow-view.component';
import { DatePickerDisplayComponent } from './components/summary/component-displays/date-picker-display/date-picker-display.component';
import { QueryButtonDisplayComponent } from './components/summary/component-displays/query-button-display/query-button-display.component';
import { DomainDrivenDisplayComponent } from './components/summary/component-displays/domain-driven-display/domain-driven-display.component';
import { ListEntryComponent } from './components/list-entry/list-entry.component';
import { CasingPlanSchematicComponent } from './components/casing-plan-schematic/casing-plan-schematic.component';
import { FileParserComponent } from './components/file-parser/file-parser.component';
import { CasingPlanSchematicModalComponent } from './components/casing-plan-grid/casing-plan-schematic-modal/casing-plan-schematic-modal.component';
import { BulkWellTransferParserComponent } from './components/bulk-well-transfer-parser/bulk-well-transfer-parser.component';


@NgModule({ declarations: [
        LabelComponent,
        CheckboxComponent,
        TextboxComponent,
        EmptyComponent,
        FlowDataTableComponent,
        DropdownComponent,
        TextAreaComponent,
        ListComponent,
        AddressComponent,
        SummaryComponent,
        ReviewCommentsComponent,
        RadioComponent,
        ButtonLinkComponent,
        YesNoToggleComponent,
        MultiselectCheckboxComponent,
        ReportHeaderImageComponent,
        ReportHeaderDefaultComponent,
        ReportFooterDefaultComponent,
        PdfGeneratorComponent,
        ESignatureComponent,
        ChiefsSignatureComponent,
        ReportTemplateSelectorComponent,
        ReportTemplateEditorComponent,
        ReportPdfViewComponent,
        MapControlComponent,
        RouteControlComponent,
        DataQueryButtonComponent,
        PhoneInputComponent,
        FileUploadDisplayComponent,
        TextboxDisplayComponent,
        AreaOfReviewMapComponent,
        FlowPdfViewerComponent,
        SummaryItemComponent,
        NewCasingPlanComponent,
        CasingPlanGridComponent,
        NewCasingPlanBackgroundInfoComponent,
        WellSegmentWizardComponent,
        WellSegmentPrecisComponent,
        CasingDataPagesComponent,
        CasingPlan2dDetailVerticalComponent,
        CasingPlan2dDetailHorizontalComponent,
        CasingPlan2dDetailBaseComponent,
        CasingPlan2dDetailDirectionalComponent,
        CasingPlanAlertComponent,
        CasingSizeAndDepthComponent,
        GoToPageDisplayComponent,
        SummaryConfigItemComponent,
        DatePickerComponent,
        DefaultDisplayComponent,
        CheckboxDisplayComponent,
        SummaryFlowViewComponent,
        DatePickerDisplayComponent,
        QueryButtonDisplayComponent,
        DomainDrivenDisplayComponent,
        ListEntryComponent,
        CasingPlanSchematicComponent,
        FileParserComponent,
        CasingPlanSchematicModalComponent,
        BulkWellTransferParserComponent
    ], imports: [CommonModule,
        NgxMaskModule,
        FormsModule,
        AccordionModule,
        ReactiveFormsModule,
        LunaCommonModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        NgxExtendedPdfViewerModule,
        PipesModule,
        DataTableModule,
        FormControlBaseModule,
        FroalaEditorModule,
        FroalaViewModule,
        FileUploadModule,
        GisModule,
        WellsModule], providers: [
        ReportSelectorService,
        ContextInteractionService,
        CasingPlanAlertService,
        FlowButtonOverrideService,
        NgxMaskPipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class FormControlsModule { }
